import {
  Overlay,
  OverlayPositionBuilder,
  OverlayRef,
  ViewportRuler,
} from "@angular/cdk/overlay";
import { ComponentPortal } from "@angular/cdk/portal";
import { AfterViewInit, Component, ComponentRef, HostListener, OnInit } from "@angular/core";
// import * as GSAPImport from 'gsap';
import { from, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { GlobalUtilsService } from "./global-utils.service";
import { LoadingIndicatorComponent } from "./loading-indicator.component";
import {
  ActiveBreakpoint,
  breakpointTest,
  getImagesPathsByActiveScreen,
  preloadImages,
} from "./variables";
// const GSAP = GSAPImport.gsap;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit, AfterViewInit {
  ActiveBreakpoint = ActiveBreakpoint;

  private overlayRef: OverlayRef;
  private portal: ComponentPortal<LoadingIndicatorComponent>;
  loadingIndicatorRef: ComponentRef<LoadingIndicatorComponent>;

  constructor(
    public globalUtilsService: GlobalUtilsService,
    private viewportRuler: ViewportRuler,
    private overlay: Overlay,
    private overlayPositionBuilder: OverlayPositionBuilder
  ) {
    history.pushState({}, '', '/');
  }

  @HostListener("window:popstate", ["$event"])
  onPopState(event) {
    window.location.href = 'https://wa.me/5584986845330?text=%C2%A9%20Sonora%20Musical%0A%3E%3E%0AVi%20que%20voc%C3%AA%20demonstrou%20interesse%20em%20nossos%20produtos%20%3A%20)%20Gostaria%20de%20tirar%20alguma%20d%C3%BAvida%3F';
  }

  ngOnInit() {
    this.updateViewportInfo();
    this.viewportRuler
      .change()
      .pipe(distinctUntilChanged(), debounceTime(100))
      .subscribe(() => {
        this.updateViewportInfo();
        this.globalUtilsService.viewportChanged.emit();
      });
  }

  ngAfterViewInit() {}

  private initializeOverlayAndLoadingIndicator() {
    // const positionStrategy = this.overlayPositionBuilder
    //   .global()
    //   .top('0px')
    //   .bottom('0px')
    //   .left('0px')
    //   .right('0px');
    // this.overlayRef = this.overlay.create({
    //   width: '100%',
    //   height: '100%',
    //   positionStrategy
    // });
    // this.portal = new ComponentPortal(LoadingIndicatorComponent);
    // this.loadingIndicatorRef = this.overlayRef.attach(this.portal);
    // from(
    //   preloadImages(
    //     ...getImagesPathsByActiveScreen(
    //       breakpointTest({
    //         width: window.innerWidth,
    //         height: window.innerHeight
    //       })
    //     )
    //   )
    // ).subscribe({
    //   complete: () => {
    //     this.loadingIndicatorRef.instance.leave().subscribe(() => {
    //       this.overlayRef.detach();
    //       this.globalUtilsService.initialLoadingIsFinished.emit();
    //     });
    //   }
    // });
  }

  private updateViewportInfo() {
    const viewportSize = this.viewportRuler.getViewportSize();
    const breakpoint = breakpointTest(viewportSize);
    this.globalUtilsService.activeScreen = breakpoint;
  }
}
